import { render, staticRenderFns } from "./FactorGroupItemList.vue?vue&type=template&id=fa2c4500&scoped=true&"
import script from "./FactorGroupItemList.vue?vue&type=script&lang=js&"
export * from "./FactorGroupItemList.vue?vue&type=script&lang=js&"
import style0 from "./FactorGroupItemList.vue?vue&type=style&index=0&id=fa2c4500&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa2c4500",
  null
  
)

export default component.exports